import React, { useEffect, useRef, useState } from "react";
import "./login.css";
import "../layouts/DashBoardLayouts/styles/header.css";
import sebi from "../images/sebiLogo.webp";
import azadi from "../images/azadiLogo.webp";
import { encrypt, encryptIDM } from "../utils/cipher";
import axios from "axios";
import { URL, ls } from "../variables";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { Grid } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LockIcon from "@mui/icons-material/Lock";
import { ColorRing } from "react-loader-spinner";
import { MuiOtpInput } from "mui-one-time-password-input";
import { alert } from "../utils/sweetAlert";
import { useStateValue } from "../Hooks/stateProvider";
import { verifyHash } from "../utils/verifyHash";
import Header from "../layouts/DashBoardLayouts/components/Header";

const Login = () => {
  let navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [otp, setOTP] = useState("");
  const [OTPFlag, SetOTPFlag] = useState(false);
  const [counter, setCounter] = useState(300);
  const [showPassword, setShowPassword] = useState(false);
  const loader = useRef(false);
  const [state, dispatch] = useStateValue();
  const [loginClicked, setLoginClicked] = useState(false)
  const [otpClicked, setOtpClicked] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const sanitizeEmail = (email) => {
    const emailRegex =
      /^[a-zA-Z0-9.!#$%+&'*\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,24}$/;
    return emailRegex.test(email) ? email : "";
  };

  useEffect(() => {
    const timer =
      counter > 0 &&
      setInterval(() => setCounter((prevCounter) => prevCounter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  // Format the counter into mm:ss
  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
      2,
      "0"
    )}`;
  };

  const handleChange = (newValue) => {
    setOTP(newValue);
  };
  const loginHandeler = async (e) => {
    e.preventDefault();
    setIsDisabled(true);
    loader.current = true;
    let userEmail = email == undefined ? " " : email.trim();
    userEmail = userEmail.toLowerCase();
    // console.log("userEmail.length", userEmail.length);
    if (sanitizeEmail(userEmail) === "") {
      alert(
        "Invalid credentials!",
        "warning"
      );
      loader.current = false;
      setIsDisabled(false);
      return;
    }
    if (pwd === "") {
     alert(
        "Invalid credentials!",
        "warning"
      );
      setIsDisabled(false);
      loader.current = false;
      return;
      }
      const payload = {
        email: userEmail,
        password: pwd,
        appType: "pms",
      };
      let encryptedPayload = await encryptIDM(payload);
      axios
        .post(URL.IDM_BACKEND_URL + "/api/auth/login", {
          payload: encryptedPayload,
        })
        .then((response) => {
          if (response?.data?.type == "success") {
            ls.set("userType", response.data.details.userType);
            handleSendOTP();
            setLoginClicked(true)

            ls.set("reportType", response.data?.details?.reportType);
            if (ls.get("userType") == "PMS") {
              // ls.set("pmsName", response.data.details.pmsCode);
              ls.set("pmsName", response.data.details.pmsCode);
              ls.set("pmsCode", response.data.details.pmsCode);
              ls.set("userType", response.data.details.userType.toUpperCase());
              ls.set("email", response.data.details.user.email);

              ls.set("originalPMSName", response.data.details.pmsName);
              dispatch({
                type: "SET_OpenNestedList",
                pmsOpenNestedList: {
                  localCMMTypeData: ["Compliance Reporting Category 1"],
                  localRemarksData: [],
                  localStatusData: ["open"],
                  localGuidanceData: [],
                },
              });
            } else if (ls.get("userType") == "SEBI") {
              ls.set("fundAccess", response.data.details.app.reports);
              ls.set("reportType", response.data.details.app.reports);
              ls.set("userType", response.data.details.userType.toUpperCase());
              ls.set("email", response.data.details.user.email);

              ls.set(
                "userName",
                response.data.details.firstName +
                " " +
                response.data.details.lastName
              );
              ls.set("division", response.data.details.division);
              dispatch({
                type: "SET_OpenNestedList",
                pmsOpenNestedList: {
                  localCMMTypeData: ["Compliance Reporting Category 1"],
                  localRemarksData: [],
                  localStatusData: ["open (sebi)"],
                  localGuidanceData: [],
                  localQuarterData: ["Q1"],
                },
              });
            }
            else {
              ls.set("apmiiname", response.data.details.firstName + " " + response.data.details.lastName);
              ls.set("pmsCode", response.data.details.secondName);
              ls.set("userType", response.data.details.userType);
              ls.set("email", response.data.details.user.email);
            }
          }
          loader.current = false;
          setIsDisabled(false);
        })
        .catch((err) => {
          setIsDisabled(false);
          loader.current = false;
          if (err?.request?.status == 429) {
            alert("Error Occured!!", err?.response?.data?.message, "error");
          } else {
            if (
              err?.response?.data?.message ==
              "You are already logged in elsewhere."
            ) {
              Swal.fire({
                title: "Session Alert!",
                html: `<span style="font-weight: bold;">You are logged in on another device. Click the button below to log out from all devices and re-login.</span>`,
                icon: "warning",
                confirmButtonColor: "#154063",
                confirmButtonText: "Log Out",
              }).then((result) => {
                if (result.isConfirmed) {
                  axios
                    .post("/api/pms/logout", {
                      withCredentials: true,
                      email: email,
                    })
                    .then((res) => {
                      navigate("/");
                      ls.removeAll()
                    })
                    .catch((error) => {
                      console.log("error: ", error);
                    });
                }
              });
            } else {
              alert(
                err?.response?.data?.message || "Something went wrong!!",
                "",
                "error"
              );
            }
          }
        })
      .finally(() => {
        loader.current = false;
        setIsDisabled(false);
       });
  };

  const handleSendOTP = async (e) => {
    // e.preventDefault();
    let userEmail = email == undefined ? " " : email.trim();
    userEmail = userEmail.toLowerCase();
    // let emailOTP="mithileshkumar.mahatha@kfintech.com"

    const payload = {
      email: userEmail,
    };

    let encryptedPayload = await encryptIDM(payload);

    axios
      .post(URL.IDM_BACKEND_URL + "/api/sebi/sendOtp", {
        payload: encryptedPayload,
      })
      .then((response) => {
        if (response.data.type == "success") {
          const { hash, ...responseData } = response.data;
          setLoginClicked(false)
          if (verifyHash(responseData, hash)) {
            setCounter(300);
            SetOTPFlag(true);
          } else {
            alert(
              "Error Occured!!",
              "Response has been tampered with!",
              "error"
            );
          }
        }
      })
      .catch((err) => {
        if (err?.request?.status == 429) {
          alert("Error Occured!!", err?.response?.data?.message, "error");
        } else {
          alert(
            "Something went wrong!!",
            "",
            "error"
          );
        }
      });
  };
  const VerifyOTPHandeler = async (e) => {
    e.preventDefault();
    setIsDisabled(true);
    loader.current = true;
    let userEmail = email == undefined ? " " : email.trim();

    userEmail = userEmail.toLowerCase();
    if (otp === "") {
      alert("Please Enter the OTP!", "", "warning");
      loader.current = false;
      setIsDisabled(false);
      return;
    }
      const payload = {
        email: userEmail,
        userOtp: otp,
      };
      let encryptedPayload = await encryptIDM(payload);

      axios
        .post(URL.IDM_BACKEND_URL + "/api/sebi/verifyOtp", {
          payload: encryptedPayload,
        })
        .then(async (response) => {
          if (response.data.type == "success") {
            setOtpClicked(true);
            let encryptedPayload = await encrypt({
              email: userEmail,
              password: pwd,
              userType: ls.get("userType"),
            });
            axios
              .post(
                "/api/pms/createToken",
                {
                  payload: encryptedPayload,
                },
                {
                  withCredentials: true,
                }
              )
              .then((res) => {
                if (res.data.success) {
                  alert("Verified", "", "success");
                  ls.set("userManual", res.data.s3FileLocation);
                  ls.set("years", res.data.years);
                  ls.set("isUserLoggedIn", true);
                  ls.set("authToken", res.data.authToken);
                  ls.set("refreshToken", res.data.refreshToken);
                  ls.set("userInfo", {
                    email: userEmail,
                    password: pwd,
                    userType: ls.get("userType"),
                  });
                  if (ls.get("userType") == "PMS") {
                    navigate("/app/welcome");
                  }
                  else if (ls.get("userType") == "APMII") {

                    dispatch({ type: "moduleType", moduleType: "GENERAL" })
                    navigate('/app/Analytics')
                  }

                  else {
                    navigate("/app/welcome");
                  }
                }
                setIsDisabled(false);
              });
          } else {
            alert("Wrong OTP!", "", "error");
            setOtpClicked(false);
            setIsDisabled(false);
          }
          loader.current = false;
        })
        .catch((err) => {
          loader.current = false;
          if (err?.request?.status == 429) {
            alert("Error Occured!!", err?.response?.data?.message, "error");
          } else {
            alert(
              "Something went wrong!!",
              "",
              "error"
            );
          }
          setOtpClicked(false);
          console.log("ERROR", err);
          })
      .finally(() => {
        loader.current = false;
        setIsDisabled(false);
      });
  };

  useEffect(() => {
    function alreadyLoggedIn() {
      if (ls.get("userType") == "PMS") {
        navigate("/app/welcome");
      }
      else if (ls.get("userType") == "APMII") {

        dispatch({ type: "moduleType", moduleType: "GENERAL" })
        navigate('/app/ReportGenModule')
      }

      else {
        navigate("/app/welcome");
      }
    }

    if(ls.get("isUserLoggedIn")){
      alreadyLoggedIn()
    }

  }, [])
  return (
    <>
      <Header />
      {OTPFlag == true ? (
        <Grid
          container
          className="gridContainer"
          alignItems={"center"}
          justifyContent={"center"}
        >
          <Grid item xs={6} sm={5} md={3} lg={3} className="main-body">
            <form className="login-card" onSubmit={VerifyOTPHandeler}>
              <p style={{ textAlign: "center", width: "100%", margin: "0" }}>
                OTP has been sent to <br />
                {email.toLowerCase().substring(0, 2) +
                  "*".repeat(
                    email.substring(3, email.indexOf("@"))?.length - 1 > 0 ? email.substring(3, email.indexOf("@"))?.length - 1 : 1
                  ) +
                  email.slice(email.indexOf("@") - 2, email.length)}
              </p>
              <div style={{ margin: "2rem 0 1rem 0" }}>
                <MuiOtpInput
                  length={6}
                  autoFocus
                  value={otp}
                  onChange={handleChange}
                  sx={{
                    "& .MuiOutlinedInput-input": {
                      height: "1rem !important",
                    },
                  }}
                />
              </div>

              <div className="forget-password">
                {counter != 0 ? (
                  <a href="#" style={{ pointerEvents: "none" }}>
                    {counter < 10
                      ? `Resend OTP in ${formatTime(counter)}`
                      : `Resend OTP in ${formatTime(counter)}`}
                  </a>
                ) : (
                  <a href="#" onClick={handleSendOTP}>
                    Resend OTP
                  </a>
                )}
              </div>

              <button
                type="submit"
                className="login-button"
                disabled={isDisabled || otpClicked} 
              >
                {loader.current ? (
                  <ColorRing
                    height="1.2rem"
                    colors={["#fff", "#fff", "#fff", "#fff", "#fff"]}
                  />
                ) : (
                  "SUBMIT OTP"
                )}
              </button>
            </form>
          </Grid>
        </Grid>
      ) : (
        <Grid
          container
          className="gridContainer"
          alignItems={"center"}
          justifyContent={"center"}
        >
          <Grid item xs={6} sm={5} md={3} lg={3} className="main-body">
            <form onSubmit={loginHandeler} className="login-card">
              <div className="input-group">
                <AccountCircleIcon sx={{ color: "#58585e" }} />
                <input
                  type="email"
                  id="userid"
                  placeholder="Registered APMI Id"
                  required
                  onChange={(e) => setEmail(e.target.value)}
                  maxLength={255}
                />
              </div>

              <div className="input-group">
                <LockIcon sx={{ color: "#58585e" }} />
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  placeholder="Password"
                  required
                  onChange={(e) => setPwd(e.target.value)}
                  maxLength={64}
                />
                {!showPassword ? (
                  <VisibilityOffIcon
                    style={{ cursor: "pointer", color: "#58585e" }}
                    onClick={() => {
                      setShowPassword(true);
                    }}
                  />
                ) : (
                  <VisibilityIcon
                    style={{ cursor: "pointer", color: "#58585e" }}
                    onClick={() => {
                      setShowPassword(false);
                    }}
                  />
                )}
              </div>

              <div className="forget-password">
                <a href={URL.FORGOT_PASSWORD_URL}>Reset Password?</a>
              </div>

              <button
                type="submit"
                className="login-button"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: isDisabled ? 'not-allowed' : 'pointer'
                }}
                disabled={isDisabled || loginClicked}
              >
                {loader.current ? (
                  <ColorRing
                    height="1.2rem"
                    colors={["#fff", "#fff", "#fff", "#fff", "#fff"]}
                  />
                ) : (
                  "SIGN IN"
                )}
              </button>
            </form>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default Login;